import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formStates } from './';
import ResetPasswordForm from './components/reset-password-form/ResetPasswordForm';
import { resetPassword } from '../../api/actions';
import { DocumentTitle } from '../../components';
import { useLocation } from 'react-router-dom';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { errorMessages } from '../../utils/translateErrorCode/translateErrorCode';

export class ResetPassword extends Component {
  static propTypes = {
    invalidResetPasswordToken: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    errors: {
      email: '',
      invalidResetPasswordToken: false,
      resetPassword: '',
    },
    formState: formStates.INITIAL,
  };

  render() {
    const headerText = this.isFormInSuccessState()
      ? 'Please follow the instructions sent to your email.'
      : 'Forgot your password?';
    return (
      <DocumentTitle title={'SolarWinds Cloud'}>
        <UnifiedLayout headerText={headerText} dataTestPageName="ResetPassword">
          {this.renderResetPasswordForm()}
        </UnifiedLayout>
      </DocumentTitle>
    );
  }

  renderResetPasswordForm() {
    return (
      <ResetPasswordForm
        isLoading={this.isFormInLoadingState()}
        email={this.state.email}
        errors={this.getErrors()}
        handleSubmit={this.handleSubmit}
        handleChangeEmail={this.handleChangeEmail}
        handleEmailError={this.handleEmailError}
        renderSuccess={this.isFormInSuccessState()}
      />
    );
  }

  isFormInSuccessState() {
    return this.state.formState === formStates.SUCCESS;
  }

  isFormInLoadingState() {
    return this.state.formState === formStates.LOADING;
  }

  handleSubmit = async () => {
    try {
      this.startLoading();
      await this.props.resetPassword(this.state.email);
      this.setFormSuccessState();
    } catch (error) {
      this.setErrors({ resetPassword: errorMessages.internal_server_error });
      this.stopLoading();
    }
  };

  startLoading() {
    this.setState({ formState: formStates.LOADING });
  }

  stopLoading() {
    this.setState({ formState: formStates.INITIAL });
  }

  setFormSuccessState() {
    this.setState({ formState: formStates.SUCCESS });
  }

  setErrors(errors) {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        ...errors,
      },
    }));
  }

  handleEmailError = error => {
    this.setState(prevState => ({ errors: { ...prevState.errors, email: error } }));
  };

  handleChangeEmail = email => {
    this.setState(prevState => ({ email, errors: { ...prevState.errors, email: '' } }));
  };

  getErrors() {
    return {
      email: this.state.errors.email,
      invalidResetPasswordToken: this.props.invalidResetPasswordToken,
      resetPassword: this.state.errors.resetPassword,
    };
  }
}

const ResetPasswordWithInvalidResetPasswordToken = Component => props => {
  return (
    <Component invalidResetPasswordToken={IsInvalidResetPasswordToken()} resetPassword={resetPassword} {...props} />
  );

  function IsInvalidResetPasswordToken() {
    return Boolean(useLocation()?.state?.invalidResetPasswordToken);
  }
};

export default ResetPasswordWithInvalidResetPasswordToken(ResetPassword);
